import { AppRoutesApi } from "../../config/appRoutes";
import { ApiSchemaAdmin } from "../../models/api/apiSchemaAdmin";
import { AxiosAuth } from "../axios";
import { ApiResponseContainer } from "../../models/api/apiResponseContainer";

type ChangePasswordType = {
  CurrentPassword: string;
  NewPassword: string;
};

const getAdminList = async () => {
  const res = await AxiosAuth.get<ApiResponseContainer<ApiSchemaAdmin[]>>(
    AppRoutesApi.Admin.AdminList
  );
  return res.data;
};

const getAdminDataById = async (accountId: string) => {
  const res = await AxiosAuth.get<ApiResponseContainer<ApiSchemaAdmin>>(
    AppRoutesApi.Admin.AdminDataById(accountId)
  );
  return res.data;
};

const createAdmin = async (
  email: string,
  userName: string,
  password: string,
  confirmPassword: string,
  firstName: string,
  lastName: string,
  companyName: string,
  address: string,
  state: string,
  countryId: string,
  role: string
) => {
  const res = await AxiosAuth.post<ApiResponseContainer<ApiSchemaAdmin>>(
    AppRoutesApi.Admin.AdminCreate,
    {
      email,
      userName,
      password,
      confirmPassword,
      firstName,
      lastName,
      companyName,
      address,
      state,
      countryId,
      role,
    }
  );
  return res.data;
};

const deleteAdmin = async (accountId: string) => {
  const res = await AxiosAuth.post(AppRoutesApi.Admin.AdminDelete(accountId));
  return res.data;
};

const updateAdmin = async (
  Id: string,
  password: string,
  confirmPassword: string,
  firstName: string,
  lastName: string,
  companyName: string,
  address: string,
  state: string,
  countryId: string
) => {
  const body = {
    Id: Id,
    Password: password,
    ConfirmPassword: confirmPassword,
    FirstName: firstName,
    LastName: lastName,
    CompanyName: companyName,
    Address: address,
    State: state,
    CountryId: countryId,
  };
  const res = await AxiosAuth.post<ApiResponseContainer<ApiSchemaAdmin>>(
    AppRoutesApi.Admin.AdminUpdate,
    body
  );
  return res.data;
};

const activeStatus = async (Id: string, IsActive: boolean) => {
  const body = {
    Id: Id,
    IsActive: IsActive,
  };
  const res = await AxiosAuth.post<ApiResponseContainer<ApiSchemaAdmin>>(
    AppRoutesApi.Admin.AdminToggleStatus(Id),
    body
  );
  return res.data;
};

const changePassword = async (currentPassword: string, newPassword: string) => {
  const res = await AxiosAuth.post<ChangePasswordType>(
    AppRoutesApi.Auth.ChangePassword,
    {
      currentPassword,
      newPassword,
    }
  );
  return res.data;
};

export const ApiAdmin = {
  getAdminList,
  createAdmin,
  deleteAdmin,
  updateAdmin,
  getAdminDataById,
  activeStatus,
  changePassword,
};
